module.exports = __webpack_public_path__ + "img/sunich-gray.ee7ca4f.png";